import { useEffect, useState, useContext } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { ConfigContext } from '../contexts/ConfigContext';
import { Alert, Row, Col, Badge, Card } from 'react-bootstrap';
import { Tooltip } from '@mui/material';
import moment from 'moment';
import axios from '../services/axios';
import { CalcularDataExpiracao } from '../components/Utilitarios/Funcoes';
import { decode as base64_decode } from 'base-64';
import { is } from 'date-fns/locale';

export default function useModuloControle() {
  const location = useLocation();
  const history = useHistory();
  const configContext = useContext(ConfigContext);
  const { updateDataIni, moduloAtual } = configContext.state;
  const [notificacao, setNotificacao] = useState('');
  const [textoNotificacao, setTextoNotificacao] = useState('');
  const [bloquearMenu, setBloquearMenu] = useState({ gestao: false, resgate: false });
  const [loading, setLoading] = useState(true);
  const [aplicativosAtivos, setAplicativosAtivos] = useState([]);

  useEffect(() => {
    const fetchAplicativosAtivos = async () => {
      try {
        const response = await axios.get('/api/aplicativos/', {dest: 'cards'});
        //somente os que estão com o status = '2' (contratados) ou status = '4' (em teste)
        setAplicativosAtivos(response?.data?.filter(app => app.status === '2' || app.status === '4'));
      } catch (error) {
      }
    };

    fetchAplicativosAtivos();
  }, []);

  // === Sessão decodificada === //
  const storageBase64 = sessionStorage.getItem('ddesp');
  const sessao = storageBase64 ? JSON.parse(base64_decode(storageBase64)) : null;

  
  const dadosSessao = {
    usuarioId: sessao?.[3],
    planoId: sessao?.[8],
    primeiroAcesso: !!sessao?.[11]?.[0]?.primeiroAcesso,
    possuiEmpresas: sessao?.[11]?.[0]?.possuiEmpresas,
    menuGestao: sessao?.[10]?.[0]?.[0],
    menuResgate: sessao?.[10]?.[0]?.[1],
    possuiCertificado: !!sessao?.[11]?.[0]?.possuiCert,
    contaBloqueada: sessao?.[28] === 't',
    dataDemonstracao: sessao?.[27],
    ativouTesteGestao: sessao?.[31] !== null,
    dataTesteGestao: sessao?.[31],
    dataExpiracaoTesteGestao: moment(sessao?.[31]).startOf('day').add(6, 'days'),
    expirouDemonstracao: !!sessao?.[29],
    expirouTesteGestao: !!sessao?.[32],
    duplicidadeCadastro: !!sessao?.[33],
    aplicativosAtivos: aplicativosAtivos,
   
  };




  // === Regras === //
  const isDemonstracao = dadosSessao.planoId === '5'; // Plano de demonstração
  const isPlanosGestao = ['1', '2', '3'].includes(dadosSessao.planoId); // Gestão módulo 0
  const isPlanoResgate = dadosSessao.planoId === '4'; // Resgate XML módulo 1
  const podeTestarGestao = isPlanoResgate && !dadosSessao.ativouTesteGestao; // Pode testar gestão se for o plano ResgateXML e ainda não ativou o teste de gestão
  const isTesteGestao = dadosSessao.ativouTesteGestao && !dadosSessao.expirouTesteGestao && isPlanoResgate; // Usuário ativou o teste do Gestão
  // const  mfaObrigatorio = sessao?.[36]?.[3] === true;
  const  [mfaObrigatorio, setMfaObrigatorio] = useState(sessao?.[36]?.[3] === true || sessao?.[36]?.[3] === 't');
  const mfaAtivo = sessao?.[36]?.[0] === true || sessao?.[36]?.[0] === 't';
  useEffect(() => {
    if (!sessao) return;
    const rotaAtual = location.pathname.split('/')[1];

    
    setBloquearMenu({
      gestao:
        dadosSessao.primeiroAcesso ||
        !dadosSessao.possuiEmpresas ||
        dadosSessao.contaBloqueada ||
        dadosSessao.expirouDemonstracao ||
        dadosSessao.expirouTesteGestao ||
        podeTestarGestao,

      resgate:
        dadosSessao.contaBloqueada ||
        dadosSessao.expirouDemonstracao ||
        !dadosSessao.possuiEmpresas,

    });

    const notificarTeste = () => {
      const dataAtivacao = isDemonstracao
        ? moment(dadosSessao.dataDemonstracao).startOf('day')
        : moment(dadosSessao.dataTesteGestao).startOf('day');

      const { diasRestantes, expirado } = CalcularDataExpiracao(dataAtivacao, 6);
      
      
      if (rotaAtual === 'inicio') return;

      if (expirado) {
        setTextoNotificacao(
          <span>
            ⌛ Seu período de testes expirou. <strong>Contrate já</strong> e continue utilizando o sistema.
          </span>
        );
      } else {
        setTextoNotificacao(
          diasRestantes === 0 ? (
            <span>
              ⌛ Hoje é seu último dia de teste! <strong>Não perca tempo, contrate agora</strong> e continue aproveitando o sistema.
            </span>
          ) : (
            <span>
              ⌛ {diasRestantes > 1 ? 'Faltam' : 'Falta'} <strong>{diasRestantes} dia{diasRestantes > 1 ? 's' : ''}</strong> para o fim do seu período de teste.
            </span>
          )
        );
      }
    };

    const montarNotificacao = () => {
      const estaTestandoGestao = isPlanoResgate && isTesteGestao;
      const mostrarNotificacaoTeste = isDemonstracao || estaTestandoGestao;
      if (mostrarNotificacaoTeste) {
        notificarTeste();
        setNotificacao(

          <Alert variant={moduloAtual === 0 ? 'primary' : 'info'} className="text-center p-1">
            <span
              className="icon-warning ml-2 float-left position-relative"
              style={{ top: '2px' }}
            />
            <span className="text-secondary f-16">{textoNotificacao}</span>
            <Tooltip title={`Assinar ${moduloAtual === 0 ? 'Gestão' : 'Resgate XML'}`}>
              <Badge
                variant="success"
                className="f-w-400 f-14 ml-3 pointer"
                onClick={() =>
                  history.push(moduloAtual === 0 ? '/planos' : '/resgate/planos')
                }
              >
                Assinar
              </Badge>
            </Tooltip>
            <span
              className="float-right pointer mr-2 f-w-600 mdi mdi-close position-relative"
              style={{ top: '2px' }}
              onClick={() => setNotificacao('')}
            >
            </span>
          </Alert>
        );
      } else {
        const dataPost = [dadosSessao.planoId === '5' ? 2 : 1];
        axios
          .get('api/initData/', { dest: 'notificacoes', dataPost })
          .then((response) => {
            const dado = response.data?.[0];
            if (dado) {
              setNotificacao(
                <Row>
                  <Col md={12}>
                    <Alert variant={dado.fundo} className="text-center p-1 ">
                      <span className={`${dado.icone} ml-2 float-left position-relative`} style={{ top: '2px' }} />
                      <span className={`${dado.cor_fonte} f-16`}>{dado.texto}</span>
                      {dado.link && (
                        <a className="badge badge-success f-w-400 ml-3 pointer position-relative" target="_blank" rel="noreferrer" href={dado.link}>
                          Saiba mais
                        </a>
                      )}
                      <span className="float-right pointer mr-2 f-w-600 mdi mdi-close-circle position-relative" style={{ top: '2px' }} onClick={() => setNotificacao('')} />
                    </Alert>
                  </Col>
                </Row>
              );
            }
          })
          .catch(() => {});
      }
    };

    montarNotificacao();

    const sessionData = sessionStorage.getItem('ddesp');
    const decodedSession = sessionData ? JSON.parse(base64_decode(sessionData)) : null;
    const mfaObrigatorio_ = decodedSession?.[36]?.[3] === true || decodedSession?.[36]?.[3] === 't';
    // const mfaAtivo = decodedSession?.[36]?.[0] === true || decodedSession?.[36]?.[0] === 't';

    setMfaObrigatorio(mfaObrigatorio_);
    if (mfaObrigatorio_ && !mfaAtivo) {
       if (!location.pathname.includes('seguranca')) {
         window.location.href = '/seguranca?tab=abaMfa'; // ajustar para a rota correta
         return;
       }
     }
  }, [updateDataIni, moduloAtual, sessionStorage.getItem('ddesp')]);

  // === Retorno do hook === //
  return {
    ...dadosSessao,
    isDemonstracao,
    isTesteGestao,
    isPlanosGestao,
    isPlanoResgate,
    podeTestarGestao,
    bloquearMenu,
    notificacao,
  };
}
